import { render, staticRenderFns } from "./DoughnutReviewDelivery.vue?vue&type=template&id=7e77ce8b&scoped=true&"
import script from "./DoughnutReviewDelivery.vue?vue&type=script&lang=js&"
export * from "./DoughnutReviewDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutReviewDelivery.vue?vue&type=style&index=0&id=7e77ce8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e77ce8b",
  null
  
)

export default component.exports